import { r as register } from './swiper-element-bundle-C6yW3Oh8.js';
import './a11y-F8w-t6Vr.js';
import './pagination-Dw_1wJjf.js';
import './autoplay-qizOvqdu.js';
import './thumbs-DDNPYh3W.js';

register();

const initSlider = () => {
  const swiperEl = document.querySelector('.featured-products-slider');
  if (!swiperEl) return;

  const productsAlignment = swiperEl.getAttribute('data-products-alignment');

  const params = {
    injectStyles: [
      `
        .swiper {
          overflow: visible !important;
        }
        .swiper-wrapper {
          padding-bottom: 24px !important;
        }
        .swiper-wrapper {
          ${productsAlignment}
        }
        .swiper-scrollbar .swiper-scrollbar-drag {
          background-color:  var(--swiper-theme-brand-color) !important;
        }
        `,
    ],
    slidesPerView: 2.1,
    spaceBetween: 16,
    scrollbar: {
      enabled: true,
    },
    breakpoints: {
      1024: {
        slidesPerView: 4.1,
      },
    },
  };

  Object.assign(swiperEl, params);
  swiperEl.initialize();
};

// Initialize on page load
initSlider();

// Reinitialize when Shopify editor makes changes
document.addEventListener('shopify:section:load', initSlider);
